import Shuffle from 'shufflejs';

document.addEventListener('DOMContentLoaded', () => {
  const shuffleEl = document.querySelector('.my-shuffle');
  if (shuffleEl){
    const myShuffle = new Shuffle( shuffleEl, {
      itemSelector: '.js-item',
      sizer: '.my-sizer-element',
      buffer: 1,
      easing:  'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
      roundTransforms: true,
      speed: 300,
      staggerAmount: 50,
      staggerAmountMax: 150,
      //useTransforms: true,
    });
  }
});


// WEBPACK FOOTER //
// ./scripts/blocks/shuffle.js